module.exports = __webpack_public_path__ + "img/ABC.4f5f8546.jpeg";